import {RecalboxRGBDualManualPage} from "../../features/rgbdual/RecalboxRGBDualManualPage"

export default RecalboxRGBDualManualPage.Page
